/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StructuredContractResponse } from './StructuredContractResponse';
import {
    StructuredContractResponseFromJSON,
    StructuredContractResponseFromJSONTyped,
    StructuredContractResponseToJSON,
    StructuredContractResponseToJSONTyped,
} from './StructuredContractResponse';

/**
 * 
 * @export
 * @interface GetPayerContractStructuredContract200Response
 */
export interface GetPayerContractStructuredContract200Response {
    /**
     * 
     */
    data?: StructuredContractResponse;
}

/**
 * Check if a given object implements the GetPayerContractStructuredContract200Response interface.
 */
export function instanceOfGetPayerContractStructuredContract200Response(value: object): value is GetPayerContractStructuredContract200Response {
    return true;
}

export function GetPayerContractStructuredContract200ResponseFromJSON(json: any): GetPayerContractStructuredContract200Response {
    return GetPayerContractStructuredContract200ResponseFromJSONTyped(json, false);
}

export function GetPayerContractStructuredContract200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayerContractStructuredContract200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : StructuredContractResponseFromJSON(json['data']),
    };
}

export function GetPayerContractStructuredContract200ResponseToJSON(json: any): GetPayerContractStructuredContract200Response {
    return GetPayerContractStructuredContract200ResponseToJSONTyped(json, false);
}

export function GetPayerContractStructuredContract200ResponseToJSONTyped(value?: GetPayerContractStructuredContract200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StructuredContractResponseToJSON(value['data']),
    };
}

